import oposLogo from '../../assets/opos-logo.png';

/**
 * OposLogo
 * Renders the OPOS icon image and wordmark.
 */
export default function OposLogo({ size = 'md' }) {
    const sizes = {
        sm: { mark: 28, text: 14 },
        md: { mark: 34, text: 16 },
        lg: { mark: 44, text: 20 }
    };

    const s = sizes[size] || sizes.md;

    return (
        <div className="flex items-center gap-2.5">
            <img
                src={oposLogo}
                alt=""
                aria-hidden="true"
                width={s.mark}
                height={Math.round(s.mark * 0.88)}
                className="object-contain"
            />
            <span
                style={{ fontSize: s.text, fontWeight: 700, color: '#1B2F7E', letterSpacing: '-0.3px' }}
                aria-label="OPOS"
            >
                OPOS
            </span>
        </div>
    );
}
